module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/people_b2-1323398c6fa8e1cb8aa6b853661b2673.svg";